/**
 * Created by calhosh on 11/20/2024
 */
import React, {Fragment} from 'react';
import CharCount from './CharCount';
import styled from 'styled-components';

export default function RichTextHeader(props) {
	const {
		charactersLabel,
		charCount,
		characterCountPrefix,
		label,
		maxCharCount,
		ofLabel,
		optional,
		optionalText,
		showCharacterCount,
		showMaxCharacterCount,
		numberFormat
	} = props;

	return (
		<StyledEditorHeader className="richtext-header">
			{label && label.length > 0 && (
				<StyledEditorLabel className="richtext-editor-label">
					<label>{label}</label>
					{optional && (
						<label>{optional && optional === true && <span className="optional-tag">{optionalText}</span>}</label>
					)}
				</StyledEditorLabel>
			)}
			{(showCharacterCount === true || showMaxCharacterCount === true) === true && (
				<StyledCharacterCount>
					<CharCount
						charactersLabel={charactersLabel}
						charCount={charCount}
						characterCountPrefix={characterCountPrefix}
						maxCharCount={maxCharCount}
						numberFormat={numberFormat}
						ofLabel={ofLabel}
						showMaxCharacterCount={showMaxCharacterCount}
					/>
				</StyledCharacterCount>
			)}
		</StyledEditorHeader>
	);
}

const StyledEditorHeader = styled.section`
	line-height: normal;
	color: var(--neutrals-700);
	display: flex;
	align-items: center;
	justify-content: space-between;
	.richtext-editor-label {
		margin-bottom: var(--px-12);
	}
`;
const StyledCharacterCount = styled.span``;

const StyledEditorLabel = styled.span`
	font-size: var(--px-14);
	font-weight: 400;
	&.disabled {
		pointer-events: none;
		opacity: 0.5;
	}
`;
